<template>
  <div>
    <v-menu
      v-model="value"
      :disabled="disabled"
      :absolute="absolute"
      :open-on-hover="openOnHover"
      :close-on-click="closeOnClick"
      :close-on-content-click="closeOnContentClick"
      :offset-x="offsetX"
      :offset-y="offsetY"
    >
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="showQA()">
          <v-list-item-title class="subtitle-2">{{ $t("message.helpTitle") }}</v-list-item-title>
        </v-list-item>
        <v-list-item :href="showHelpManualUrl()" target="_blank">
          <v-list-item-title class="subtitle-2">{{ $t("message.userManualTitle") }}</v-list-item-title>
        </v-list-item>
        <v-list-item :href="showVideoPlayerUrl()" target="_blank">
          <v-list-item-title class="subtitle-2">{{ $t("message.videoplayerTitle") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>    
  </div>
</template>

<script>
export default {
  name: "pl-help",

  data: () => ({
    //menu
    disabled: false,
    absolute: false,
    openOnHover: false,
    value: false,
    closeOnClick: true,
    closeOnContentClick: true,
    offsetX: false,
    offsetY: true
  }),

  methods: {
    showQA()
    {
      this.$store.dispatch("setShowHelpList", true);
    },

    showHelpManualUrl()
    {
      if (this.$store.getters.selectedLanguage==null)
        return ""
      else
        return "https://www.kabe-farben.ch/fileadmin/kabe-farben/pulverlack/pul_manuals/"+this.$store.getters.selectedLanguage.toUpperCase()+"_User_Manual_KABE_online_Pulverlack-Lagerliste.pdf"
    },

    showVideoPlayerUrl()
    {
      return "https://www.youtube.com/playlist?list=PLbuLPmRVteNhwxe68G1PVvQ2Jd0VkpmBv"
    }

  }

};
</script>

<style scoped>
</style>
